<template>
  <VDialog v-model="isShowModal" max-width="500">
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-information-outline" class="mr-2" />
        Confirmation
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VCardText>
          <div class="d-flex flex-column align-center justify-center">
            <VIcon icon="mdi-information" color="warning" size="64" class="my-2" />
            <p class="text-center">Are you sure you want to remove this? This action cannot be undone.</p>
          </div>
          <VRow class="mt-4">
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="red" block flat @click="handleSubmit()">
                Remove
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VCardText>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import invitesService from '@/services/invites-service/invites.service';
// Test
import { successDeleteAnswerText, errorDeleteAnswerText } from '@/text/snackbarsText';
export default {
  name: 'DeleteCategoryModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    inviteId: {
      type: String
    },
    categoryId: {
      type: String
    },
    questionId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'deleted'],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleSubmit() {
      this.isLoading = true;
      try {
        const answerData = {
          inviteId: this.inviteId,
          categoryId: this.categoryId,
          questionId: this.questionId
        };
        await invitesService.deleteSupplierAnswer(answerData);
        this.showSnackbar({ text: successDeleteAnswerText, color: 'green' });
        this.handleSuccess();
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: errorDeleteAnswerText, color: 'red' });
      } finally {
        this.isLoading = false;
      }
    },

    handleSuccess() {
      this.$emit('deleted');
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>
